import React from "react";
import ProfileViewer from "../../../../Universal/Profiles/ProfileViewer.component";

const CoAdminPermissionList = () => {
  return (
    <div
      className="w-full flex-row align-center justify-between p-1 permissionGrantedListLi"
      style={{ borderBottom: "2px solid var(--grayBorder)" }}
    >
      <div className="flex-row align-center justify-between w-half">
        <ProfileViewer
          imageSource={"https://randomuser.me/api/portraits/women/45.jpg"}
          imageWidth={"3rem"}
          imageHeight={"3rem"}
          name={"Md Rejuwanul Karim"}
          _id={"SMSSJSK"}
        />
        <span className="t-13 poppins color-greenColor">Member</span>
      </div>
      <button type="button" className="blueShadeActionBtn radius-3">
        Mark act admin
      </button>
    </div>
  );
};

export default CoAdminPermissionList;
